<template>
  <section class="ant-layout">
    <main class="ant-layout-content">
      <div class="ant-spin-nested-loading">
        <div class="ant-spin-container">
          <div class="inbox-page">
            <div class="common-header">
              <font style="vertical-align: inherit"><font style="vertical-align: inherit"> {{ $t('mine.MessageCenter') }} </font></font>
            </div>
            <div class="ant-tabs ant-tabs-top inbox-page-tabs ant-tabs-card ant-tabs-no-animation">
              <div role="tablist" tabindex="-1" class="ant-tabs-bar ant-tabs-top-bar ant-tabs-card-bar">
                <div class="ant-tabs-nav-container">
                  <div class="ant-tabs-nav-wrap">
                    <div class="ant-tabs-nav-scroll">
                      <div class="ant-tabs-nav ant-tabs-nav-animated">
                        <div>
                          <div role="tab" @click="changType(0)" aria-disabled="false" aria-selected="true" tabindex="-1" id="tab-1" aria-controls="tabpane-1" class="ant-tabs-tab">
                            <a :class="type == 0 ? 'active' : ''" 
                              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.Internalmessage') }}</font></font></a
                            >
                          </div>
                          <div role="tab" @click="changType(1)" aria-disabled="false" aria-selected="false" tabindex="-1" id="tab-2" aria-controls="tabpane-2" class="ant-tabs-tab">
                            <a :class="type == 1 ? 'active' : ''" 
                              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.Announcement') }}</font></font></a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ant-tabs-content ant-tabs-content-no-animated ant-tabs-top-content ant-tabs-card-content">
                <div role="tabpanel" aria-hidden="false" tabindex="0" class="ant-tabs-tabpane ant-tabs-tabpane-active" style="visibility: visible">
                  <div class="el-card box-card is-always-shadow">
                    <!---->
                    <div class="el-card__body" v-if="type == 0">
                      <div v-for="(item, index) in noticeList" :key="index">
                        <div style="display: flex; justify-content: space-between">
                          <span>{{ item.title }}</span> <span>{{ item.created_at }}</span>
                        </div>

                        <div v-html="item.content"></div>
                      </div>
                    </div>
                    <div class="el-card__body" v-if="type == 1">
                      <div v-for="(item, index) in homenoticelis" :key="index">
                        {{ item }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>
<script>
export default {
  name: 'message',
  data() {
    return {
      type: 0,
      noticeList: [],
      homenoticelis: [],
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.type = query.type * 1;
    }
    that.$parent.showLoading();
    that.homenotice();
    that.getDatalist();
  },
  methods: {
    changType(val) {
      if (this.type == val) {
        return;
      }
      this.type = val;
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
        }
      });
    },
    getDatalist() {
      let that = this;
      let page = that.page;
      that.$apiFun
        .post('/api/noticeList', { page })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.noticeList = res.data.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/inbox.css';
.inbox-page .inbox-page-tabs .ant-tabs-nav .ant-tabs-tab {
  box-sizing: border-box;
  width: 120px;
  border-radius: 50%;
  background-color: #f4f4f5;
  color: #666;
}
.ant-tabs-nav a {
  // color: #2ca4ef;
  color: #666;
}
.ant-tabs-nav .active {
  color: #2ca4ef !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/message.vue